var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8469 11.4919C14.8469 13.1893 13.4838 14.5651 11.8019 14.5651H4.18339C2.50152 14.5651 1.13721 13.1893 1.13721 11.4919V4.07198C1.13721 2.37518 2.50152 1 4.18339 1H11.8019C13.4838 1 14.8469 2.37518 14.8469 4.07198V11.4919V11.4919Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 11.4919C35.0002 13.1893 33.6371 14.5651 31.9552 14.5651H24.3367C22.6548 14.5651 21.2905 13.1893 21.2905 11.4919V4.07198C21.2905 2.37518 22.6548 1 24.3367 1H31.9552C33.6371 1 35.0002 2.37518 35.0002 4.07198V11.4919Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7097 31.9268C14.7097 33.6243 13.3466 35.0001 11.6647 35.0001H4.04618C2.36431 35.0001 1 33.6243 1 31.9268V24.5075C1 22.8107 2.36431 21.4355 4.04618 21.4355H11.6647C13.3466 21.4355 14.7097 22.8107 14.7097 24.5075V31.9268V31.9268Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.863 31.9268C34.863 33.6243 33.4999 35.0001 31.818 35.0001H24.1995C22.5176 35.0001 21.1533 33.6243 21.1533 31.9268V24.5075C21.1533 22.8107 22.5176 21.4355 24.1995 21.4355H31.818C33.4999 21.4355 34.863 22.8107 34.863 24.5075V31.9268V31.9268Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.4e9774fe.svg";
export { ForwardRef as ReactComponent };